module.exports = __webpack_public_path__ + "img/16_113.668ea133.png";